import AuthorLabel from './AuthorLabel';

export default AuthorLabel;
